<template><div><h1 id="drucker" tabindex="-1"><a class="header-anchor" href="#drucker"><span>Drucker</span></a></h1>
<p>Drucker — Drucker einrichten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Ermöglicht die Definition von Druckern, welche den Benutzern im Netz zur Verfügung stehen. Dabei können für einen physisch im Netz vorhandenen Drucker mehrere Definitionen erstellt werden, die z.B. Etikettendruck und Endlosformulare auszugeben ermöglichen. Die einzugebenden ESC-Sequenzen sind dem Druckerhandbuch zu entnehmen und werden für die softwaremässige Steuerung von notwendigen Druckerparametern benötigt. Der Systemverwalter kann die eingegebenen Werte testen. An gewissen Stellen können standardisierte Steuerzeichen verwendet werden, um den Output zu formatieren.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Drucker</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Drucker</dt>
<dd>Identifikator für Druckerdefinitionen und ausgeschriebene Bezeichnung</dd>
<dt>Device</dt>
<dd>Systemabhängige Bezeichnung des Druckers</dd>
<dt>Benutzer</dt>
<dd>Angabe der Benutzerkurzzeichen, die zur Ausgabe auf diesen Drucker berechtigt sind.</dd>
<dt>Kassetten</dt>
<dd>Felder für die Steuerung der Druckkassette</dd>
<dt>Max. Spalten/Zeilen:</dt>
<dd>Angabe der Seitenbreite (Anzahl Spalten) und Seitenlänge (Anzahl Zeilen).</dd>
<dt>Oberer/Linker Rand</dt>
<dd>Oberer Rand (= Anzahl Zeilen) und Linker Rand (= Anzahl Spalten)</dd>
</dl>
<p>Steuersequenzen allgemein:</p>
<dl>
<dt>Initialisierung</dt>
<dd>Initialsequenz zur Druckerinitialisierung per ESC-Sequenz</dd>
<dt>Mikroschritt</dt>
<dd>ESC-Sequenz, mit der ein Mikroschritt (bei einem Nadeldrucker) angesteuert werden kann. Wird nur selten benötigt (zur softwaremässigen Steuerung)</dd>
<dt>Neg. Zeilenschaltung</dt>
<dd>Negative Zeilenschaltung: ESC-Sequenz</dd>
<dt>Altern. Zeilensabstand</dt>
<dd>Alternativer Zeichenabstand: ESC-Sequenz</dd>
<dt>Resetsequenz</dt>
<dd>ESC-Sequenz für Resetbefehl</dd>
<dt>Schrift OCR-B</dt>
<dd>Schriftart OCR-B: wird für ESR-(Ein)drucke benötigt</dd>
<dt>Bar-Code</dt>
<dd>Schriftart für Barcode-Beschriftungen</dd>
</dl>
<p>Steuersequenzen für Schriftstile:</p>
<dl>
<dt>Standard</dt>
<dd>
<p>Normalschrift</p>
</dd>
<dt>Normal</dt>
<dd>
<p>Normalschrift</p>
</dd>
<dt>Fett</dt>
<dd>
<p>Fettschrift</p>
</dd>
<dt>Mittel</dt>
<dd>
<p>Mittlere Schrift</p>
</dd>
<dt>Unterstrichen</dt>
<dd>
<p>Unterstrichen</p>
</dd>
<dt>Breit</dt>
<dd>
<p>Breite Schrift</p>
</dd>
<dt>Kursiv</dt>
<dd>
<p>Kursiv</p>
</dd>
<dt>Schmal</dt>
<dd>
<p>Schmale Schrift</p>
</dd>
<dt>Hintergrundverarbeitung möglich?</dt>
<dd>
<p>ja = Drucker kann über einen Hintergrundjob angesprochen werden</p>
</dd>
<dd>
<p>nein = Drucker kann nur im Vordergrund drucken (in <span class="emphasis"><em><span class="application">funtrade</span></em></span> beim Drucken &quot;Hintergrund = nein&quot; wählen)</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="druckersteuerung-in-texten" tabindex="-1"><a class="header-anchor" href="#druckersteuerung-in-texten"><span>Druckersteuerung in Texten</span></a></h3>
<dl>
<dt>&lt;SB-BREIT&gt;</dt>
<dd>Breitschrift (Zeichenabstand sehr grosse Laufweite)</dd>
<dt>&lt;SB-NORMAL&gt;</dt>
<dd>Normalschrift (Zeichenabstand normale Laufweite)</dd>
<dt>&lt;SB-MITTEL&gt;</dt>
<dd>Mittelschrift (Zeichenabstand grosse Laufweite)</dd>
<dt>&lt;SB-SCHMALL&gt;</dt>
<dd>Schmalschrift (Zeichenabstand enge Laufweite)</dd>
<dt>&lt;STANDARD&gt;</dt>
<dd>Standardschrift (Schriftart Standard)</dd>
<dt>&lt;FETT&gt;</dt>
<dd>Fett (Schriftschnitt)</dd>
<dt>&lt;UNTERSTR&gt;</dt>
<dd>Unterstrichen (Schriftschnitt)</dd>
<dt>&lt;KURSIV&gt;</dt>
<dd>Kursivschrift (Schriftschnitt)</dd>
<dt>&lt;OCRB&gt;</dt>
<dd>OCR-B-Schrift (Schriftart)</dd>
<dt>&lt;BARCD&gt;</dt>
<dd>BarCode-Schrift (Schriftart)</dd>
</dl>
<p>:</p>
<dl>
<dt>Syntaxbeispiel</dt>
<dd>&quot;Dies ist &lt;KURSIV&gt;kursiver&lt;STANDARD&gt; Text&quot;</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/systemverwaltung.html" title="7. Systemverwaltung">Systemverwaltung</RouteLink></p>
</div></template>


